"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.search = search;
exports.list = list;
exports.listContact = listContact;
exports.update = update;
exports.endpoints = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _requests = require("@edison/requests");

var _functools = require("@edison/functools");

var _utils = require("./utils");

var _utils2 = require("../utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var endpoints = {
  search: {
    method: 'GET',
    url: function url() {
      return "/".concat(_utils2.API_V1, "/cleanup/search");
    }
  },
  list: {
    method: 'GET',
    url: function url() {
      return "/".concat(_utils2.API_V1, "/cleanup/list");
    }
  },
  listContact: {
    method: 'GET',
    url: function url() {
      return "/".concat(_utils2.API_V1, "/cleanup/list_contact");
    }
  },
  update: {
    method: 'POST',
    url: function url() {
      return "/".concat(_utils2.API_V1, "/cleanup/update");
    }
  }
};
/**
 * Search types of emails for to be cleaned up.
 *
 * @public
 * @param {Auth} {auth} - User authentication info
 * @returns {Promise<any>}
 */

exports.endpoints = endpoints;

function search(_x) {
  return _search.apply(this, arguments);
}
/**
 * List the thread ids of specific type of cleanup
 *
 * @public
 * @param {CleanupType} type - Cleanup type
 * @param {Auth} auth - User authentication info
 * @param {size, pageToken} {size, pageToken} - page size, page token
 * @returns {Promise<any>}
 */


function _search() {
  _search = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(auth) {
    var optionals, _endpoints$search, method, url;

    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            optionals = (0, _utils.withAuth)(auth)(_utils.defaultOptionals);
            _endpoints$search = endpoints.search, method = _endpoints$search.method, url = _endpoints$search.url;
            _context.next = 4;
            return (0, _requests.request)(url(), method, optionals);

          case 4:
            return _context.abrupt("return", _context.sent);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _search.apply(this, arguments);
}

function list(_x2, _x3, _x4) {
  return _list.apply(this, arguments);
}
/**
 * List the contacts for cleanup when 3rd account imported
 *
 * @public
 * @param {string} syncEmail - The email addreass of imported 3rd account
 * @param {Auth} auth - User authentication info
 * @returns {Promise<any>}
 */


function _list() {
  _list = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(type, auth, _ref) {
    var size, pageToken, optionals, _endpoints$list, method, url;

    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            size = _ref.size, pageToken = _ref.pageToken;
            optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withParams)({
              type: type,
              size: size,
              pageToken: pageToken
            }))(_utils.defaultOptionals);
            _endpoints$list = endpoints.list, method = _endpoints$list.method, url = _endpoints$list.url;
            _context2.next = 5;
            return (0, _requests.request)(url(), method, optionals);

          case 5:
            return _context2.abrupt("return", _context2.sent);

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _list.apply(this, arguments);
}

function listContact(_x5, _x6) {
  return _listContact.apply(this, arguments);
}
/**
 * Record the user’s action and update the status of cleanup event.
 *
 * @public
 * @param {string} type - The ID of the cleanup event
 * @param {CleanupStatus} status - Cleanup status to be modified
 * @param {Auth} {auth} - User authentication info
 * @returns {Promise<any>}
 */


function _listContact() {
  _listContact = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(syncEmail, auth) {
    var optionals, _endpoints$listContac, method, url;

    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withParams)({
              syncEmail: syncEmail
            }))(_utils.defaultOptionals);
            _endpoints$listContac = endpoints.listContact, method = _endpoints$listContac.method, url = _endpoints$listContac.url;
            _context3.next = 4;
            return (0, _requests.request)(url(), method, optionals);

          case 4:
            return _context3.abrupt("return", _context3.sent);

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _listContact.apply(this, arguments);
}

function update(_x7, _x8, _x9, _x10) {
  return _update.apply(this, arguments);
}

function _update() {
  _update = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(type, status, auth, options) {
    var optionals, _endpoints$update, method, url;

    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)(_objectSpread({
              type: type,
              status: status
            }, options)))(_utils.defaultOptionals);
            _endpoints$update = endpoints.update, method = _endpoints$update.method, url = _endpoints$update.url;
            _context4.next = 4;
            return (0, _requests.request)(url(), method, optionals);

          case 4:
            return _context4.abrupt("return", _context4.sent);

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _update.apply(this, arguments);
}
//# sourceMappingURL=cleanup.js.map